export const ACCESS_TOKEN = localStorage.getItem('accessToken');
export const ORG_ID = localStorage.getItem('orgID');
export const USER_ROLE = localStorage.getItem('userRole');
